/* EDELHOLZ Konfigurator B - adaptive Raumgrafik der Groessenberatung.
   Ausgelagert am 25.08.2026, weil die Section sonst das 256-KB-Limit reisst.
   Wird von sections/desk-con-apple-b.liquid ueber window.EHB_RAUM aufgerufen und
   bekommt seinen Kontext (state, currentModel, ...) als Objekt herein - das Modul
   kennt den Closure der Section nicht.
   Faellt das Skript aus, zeigt das Modal einfach nur den Text: kein harter Fehler. */
(function () {
  'use strict';
  var currentModel, state, root, getStandardSizesFor, setOpen, eigen;
  /* Selektor der Groessen-Chips. Default ist der Konfigurator B; der
     PDP-Minikonfigurator reicht seinen eigenen ('[data-mk-size]') herein. */
  var chipSelektor = '[data-role="size-list"] button';
  /* =====================================================================
     G3b (25.08.): Raumbedarf ADAPTIV statt statischer Zeichnung.
     Philipp: "Regler fuer die Tischgroesse, und die Masse und Verhaeltnisse
     aendern sich mit. Der Hintergrund bleibt gleich, dadurch wirkt es, als
     wuerde da wirklich was passieren."
     Darum: EIN fester Bildrahmen mit 1-m-Raster als konstante Referenz.
     Der Massstab ist je Modell fix (ausgelegt auf die groesste Groesse),
     damit 160x80 sichtbar kleiner ist als 240x108. Tisch, Bewegungsflaeche
     und Stuhl werden bei jedem Reglerschritt weich dorthin interpoliert.

     FACHLICH (Philipp 25.08.): Die SCHWEIZER KANTE ist die lange Phase an
     der Platte - sie macht die leichte Optik und KEIN Zusatzmass. Die
     +13 cm je Stirnseite kommen von der GEFALTETEN WANGE.
     ===================================================================== */
  var EHB_WANGE = 13;         /* gefaltete Wange, je Stirnseite */
  var EHB_ARC_TIEFE = 90;     /* Plattentiefe ArcPURE */
  var EHB_STUHL = 110;        /* Stuhlzone hinter der Arbeitskante */
  var EHB_WEG = 80;           /* Durchgang */
  var EHB_LUFT = 80;          /* seitlich vorbeigehen */
  var EHB_ARC_HINTEN = 55;    /* Luft hinter dem Scheitel */
  /* Wandvarianten (Philipp 01.09.): In schmalen Raeumen ist freistehend nicht
     moeglich. 10 cm Restluft, damit Sockelleiste, Kabel im Tischbein und das
     Saugen dahinter noch gehen. Sitzt eine Steckdose dahinter, sind 15 noetig -
     das steht als Hinweis im Modal, nicht als zweite Einstellung. */
  var EHB_WAND = 10;
  /* Schenkellaengen aus den Werkszeichnungen - die Produktnamen sind gerundet. */
  var EHB_ARC_SCHENKEL = { '210x210': [212, 212], '230x170': [230, 170], '260x210': [258, 213.5] };

  function ehbGeoRect(L, D, stellung) {
    var ueber = L + 2 * EHB_WANGE;
    /* Je nach Aufstellung faellt genau ein Summand weg und wird durch die
       Wandluft ersetzt. Die Stuhlzone bleibt IMMER, dort wird gearbeitet. */
    var luftL = EHB_LUFT, hinten = EHB_WEG, wand = null;
    if (stellung === 'kurz') { luftL = EHB_WAND; wand = 'links'; }
    else if (stellung === 'lang') { hinten = EHB_WAND; wand = 'oben'; }
    return { typ: 'rect', L: L, D: D, ueber: ueber,
             wand: wand, luftL: luftL, hinten: hinten,
             boxB: ueber + luftL + EHB_LUFT, boxT: D + EHB_STUHL + hinten };
  }
  function ehbGeoArc(a, b, stellung) {
    /* Geometrie nach Werkszeichnung (25.08.): Die Enden laufen ZU.
       Vordere Innenkante = Schenkel - 73 cm; die schraege Endkante ergibt sich
       daraus mit exakt ~92 cm (Zeichnung: 900 mm) - fuer alle drei Groessen
       auf den Zentimeter nachgerechnet. */
    var s60 = Math.sin(Math.PI / 3), c60 = 0.5;
    var uL = { x: -s60, y: c60 }, uR = { x: s60, y: c60 };
    var A = { x: a * uL.x, y: a * uL.y }, B = { x: b * uR.x, y: b * uR.y };
    var sy = EHB_ARC_TIEFE / Math.cos(Math.PI / 6);
    var S = { x: 0, y: sy };
    var ABZ = 73; /* Innenkante = Aussenkante - 73 cm (aus allen drei Zeichnungen) */
    var A2 = { x: S.x + (a - ABZ) * uL.x, y: S.y + (a - ABZ) * uL.y };
    var B2 = { x: S.x + (b - ABZ) * uR.x, y: S.y + (b - ABZ) * uR.y };
    var pts = [A, { x: 0, y: 0 }, B, B2, S, A2];
    /* EINE Wandvariante (Philipp 01.09.): "wand an linkem winkel ... die lange
       seite und wand haben 90 Grad winkel". Roh zeigt der linke Schenkel in
       Richtung (-sin60, cos60), also 30 Grad unter die Waagerechte - gegen
       eine senkrechte Wand kaeme so nie ein rechter Winkel zustande. Darum
       werden fuer diese Aufstellung ALLE Punkte um +30 Grad gedreht: uL
       landet exakt auf (-1, 0), der linke Schenkel liegt waagerecht und
       trifft die Wand am linken Rand senkrecht. Die 120 Grad zwischen den
       Schenkeln bleiben erhalten, und die Rueckkante (A und Scheitel) bleibt
       auf y = 0 - darum darf die Zeichenroutine weiter mit minY = 0 rechnen.
       Der Schluessel heisst 'lang' wie bei den geraden Tischen, weil der
       Knopf fachlich dasselbe meint: die lange Arbeitsseite kommt zur Wand. */
    var wandig = stellung === 'lang';
    if (wandig) {
      var c30 = Math.cos(Math.PI / 6), s30 = 0.5;
      pts = pts.map(function (p) {
        return { x: p.x * c30 - p.y * s30, y: p.x * s30 + p.y * c30 };
      });
    }
    var xs = pts.map(function (p) { return p.x; }), ys = pts.map(function (p) { return p.y; });
    var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs), maxY = Math.max.apply(null, ys);
    var spann = Math.sqrt(Math.pow(B.x - A.x, 2) + Math.pow(B.y - A.y, 2));
    /* Anzeige folgt den WERKSZEICHNUNGEN, nicht der Rundung unserer Rechnung:
       die Zeichnungen sagen 3670 / 3470 / 4080 mm - unsere Geometrie laege bei
       230x170 und 260x210 je 1 cm drueber (Philipp-Bugreport 25.08.).
       Zwischenwerte der Animation bleiben berechnet und landen exakt hier. */
    [[212, 212, 367], [230, 170, 347], [258, 213.5, 408]].forEach(function (t) {
      if (Math.abs(a - t[0]) < 0.01 && Math.abs(b - t[1]) < 0.01) spann = t[2];
    });
    /* Wandluft wie bei den geraden Tischen: 10 cm fuer Sockelleiste und
       Kabel. "Wand hinter dem Winkel" ist gestrichen (Philipp 01.09.), es
       gibt nur diese eine Wandlage, weil nur sie dem Kundenaufbau entspricht. */
    var luftL = EHB_LUFT, luftR = EHB_LUFT, hinten = EHB_ARC_HINTEN, wand = null;
    if (wandig) { luftL = EHB_WAND; wand = 'links'; }
    return { typ: 'arc', pts: pts, sy: sy, dreh: wandig ? 30 : 0,
             spann: spann,
             minX: minX, maxX: maxX, maxY: maxY,
             wand: wand, luftL: luftL, hinten: hinten,
             boxB: (maxX - minX) + luftL + luftR,
             /* Stuhlzone: 110 cm hinter der Innenecke pts[4]. Die liegt in der
                Wandvariante schon gedreht vor, darum traegt EIN Ausdruck beide
                Aufstellungen - fuer 'frei' ist pts[4].y exakt das alte sy. */
             boxT: hinten + Math.max(maxY, pts[4].y + EHB_STUHL) + EHB_WEG };
  }
  /* Aktuelle Aufstellung. 'frei' ist der Ausgangszustand und entspricht dem
     Verhalten vor dem 01.09. 'lang' gibt es fuer alle Modelle, 'kurz' nur
     fuer die geraden Tische - ein Winkel hat keine kurze Stellseite. */
  var ehbStellung = 'frei';
  function ehbGeo(modelKey, s, stellung) {
    if (modelKey === 'ArcPURE') {
      var w = EHB_ARC_SCHENKEL[s.label] || [s.L, s.D];
      return ehbGeoArc(w[0], w[1], stellung || ehbStellung);
    }
    return ehbGeoRect(s.L, s.D, stellung || ehbStellung);
  }
  var ehbM = function (cm) { return (cm / 100).toFixed(2).replace('.', ','); };

  /* Ein einziges SVG-Geruest, das nur seine Attribute aendert - kein Neuaufbau,
     damit der Wechsel als Bewegung wirkt und nicht als Bildwechsel. */
  function ehbRaumSVG() {
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 380 268');
    svg.setAttribute('class', 'ehb-raum__svg');
    svg.setAttribute('role', 'img');
    var def = document.createElementNS(NS, 'defs');
    def.innerHTML = '<clipPath id="ehbRaumClip"><rect x="0" y="0" width="380" height="268"/></clipPath>';
    svg.appendChild(def);
    var g = document.createElementNS(NS, 'g');
    g.setAttribute('clip-path', 'url(#ehbRaumClip)');
    g.innerHTML =
      '<g data-r="raster"></g>' +
      '<g data-r="wand" class="ehb-raum__wandgruppe" hidden>' +
        '<line data-r="wandlinie" class="ehb-raum__wand"/>' +
        '<path data-r="wandhatch" class="ehb-raum__wandhatch"/>' +
        '<text data-r="wandtext" class="ehb-raum__wandtext">WAND</text></g>' +
      '<rect data-r="box" rx="3" class="ehb-raum__box"/>' +
      '<text data-r="boxlabel" class="ehb-raum__boxlabel">BEWEGUNGSFLÄCHE</text>' +
      '<path data-r="platte" class="ehb-raum__platte"/>' +
      /* Wangen NACH der Platte: sie sollen oben aufliegen, nicht darunter. */
      '<rect data-r="wangeL" class="ehb-raum__wange"/>' +
      '<rect data-r="wangeR" class="ehb-raum__wange"/>' +
      '<g data-r="stuhl" class="ehb-raum__stuhl">' +
        '<rect data-r="sitz" rx="6"/><rect data-r="lehne" rx="3"/></g>' +
      /* Bemassung nach Wireframe A (Philipp 25.08.): jedes Mass klebt an dem,
         was es misst. Gesamtbreite am Tisch, Boxmasse an der gestrichelten Kante. */
      '<g data-r="mass" class="ehb-raum__mass">' +
        '<line data-r="hl1" class="ehb-raum__hilf"/><line data-r="hl2" class="ehb-raum__hilf"/>' +
        '<line data-r="ml"/><line data-r="mk1"/><line data-r="mk2"/>' +
        '<text data-r="mt" text-anchor="middle">' +
          '<tspan data-r="mtl" class="ehb-raum__mlbt"></tspan><tspan data-r="mtz"></tspan></text>' +
        '<text data-r="mlb" text-anchor="middle" class="ehb-raum__masslabel"></text></g>' +
      '<g data-r="gmass" class="ehb-raum__gmass">' +
        '<line data-r="gb"/><line data-r="gb1"/><line data-r="gb2"/>' +
        '<text data-r="gbz" text-anchor="middle"></text>' +
        '<line data-r="gr"/><line data-r="gr1"/><line data-r="gr2"/>' +
        '<text data-r="grz" text-anchor="middle"></text></g>';
    svg.appendChild(g);
    return svg;
  }

  function ehbRaumMontiere(wurzel) {
    var box = wurzel.querySelector('[data-ehb-raum]');
    if (!box) return;
    var m = currentModel();
    if (!m) return;
    var alle = getStandardSizesFor(m);
    if (!alle.length) { box.remove(); return; }
    var istArc = state.modelKey === 'ArcPURE';
    /* 29.09.: Sondermass (Konfigurator B, ab 120x60) als eigener Rastpunkt.
       state.size traegt dort nur die Abrechnungsgroesse - gezeigt wird das
       echte Kundenmass. Ohne ctx.eigen (Kaufbox) bleibt alles wie bisher. */
    var aktLabel = state.size;
    var em = (!istArc && typeof eigen === 'function') ? eigen() : null;
    if (em && em.L && em.D) {
      aktLabel = em.L + 'x' + em.D;
      if (!alle.some(function (s) { return s.label === aktLabel; })) {
        alle = alle.concat([{ label: aktLabel, L: em.L, D: em.D }])
          .sort(function (a, b) { return a.L - b.L || a.D - b.D; });
      }
    }

    /* Massstab: auf die groesste Bewegungsflaeche dieses Modells auslegen,
       danach konstant - nur so sieht man den Groessenunterschied. */
    /* Massstab immer auf 'freistehend' auslegen, nie auf die aktuelle
       Aufstellung. Sonst wuerde die Zeichnung beim Umschalten mitwachsen und
       der Gewinn an Platz waere unsichtbar - genau der Punkt der Funktion. */
    var geos = alle.map(function (s) { return ehbGeo(state.modelKey, s, 'frei'); });
    var maxB = Math.max.apply(null, geos.map(function (g) { return g.boxB; }));
    var maxT = Math.max.apply(null, geos.map(function (g) { return g.boxT; }));
    var W = 380, H = 268, PADL = 14, PADR = 32, PADT = 12, PADB = 46;
    var sk = Math.min((W - PADL - PADR) / maxB, (H - PADT - PADB) / maxT);
    var CX = PADL + (W - PADL - PADR) / 2, CY = PADT + (H - PADT - PADB) / 2;

    var svg = ehbRaumSVG();
    var flaeche = box.querySelector('[data-ehb-raum-bild]');
    flaeche.appendChild(svg);
    var el = {};
    ['raster','box','boxlabel','platte','wangeL','wangeR','stuhl','sitz','lehne',
     'wand','wandlinie','wandhatch','wandtext',
     'ml','mk1','mk2','mt','mtl','mtz','mlb','hl1','hl2','gb','gb1','gb2','gbz','gr','gr1','gr2','grz'].forEach(function (k) {
      el[k] = svg.querySelector('[data-r="' + k + '"]');
    });

    /* 1-m-Raster: bleibt ueber alle Groessen identisch und macht den
       Massstab ablesbar, ohne dass man Zahlen lesen muss. */
    (function () {
      var d = '', p = 100 * sk, i;
      for (i = -14; i <= 14; i++) {
        d += 'M' + (CX + i * p).toFixed(1) + ' 0V' + H + ' ';
        d += 'M0 ' + (CY + i * p).toFixed(1) + 'H' + W + ' ';
      }
      el.raster.innerHTML = '<path d="' + d + '" class="ehb-raum__raster"/>';
    })();

    function zeichne(g) {
      var bw = g.boxB * sk, bh = g.boxT * sk;
      var bx = CX - bw / 2, by = CY - bh / 2;
      el.box.setAttribute('x', bx.toFixed(1)); el.box.setAttribute('y', by.toFixed(1));
      el.box.setAttribute('width', bw.toFixed(1)); el.box.setAttribute('height', bh.toFixed(1));
      el.boxlabel.setAttribute('x', (bx + 9).toFixed(1));
      el.boxlabel.setAttribute('y', (by + bh - 9).toFixed(1));

      /* Wand als Strich mit Schraffur an der Aussenkante der Bewegungsflaeche.
         Ohne sichtbare Wand ist der Umschalter nicht selbsterklaerend. */
      if (g.wand) {
        el.wand.removeAttribute('hidden');
        var hatch = '', i2, WL = 7;
        if (g.wand === 'rechts') {
          var rx = bx + bw;
          el.wandlinie.setAttribute('x1', rx.toFixed(1)); el.wandlinie.setAttribute('x2', rx.toFixed(1));
          el.wandlinie.setAttribute('y1', by.toFixed(1)); el.wandlinie.setAttribute('y2', (by + bh).toFixed(1));
          for (i2 = 0; i2 < bh; i2 += 9) {
            hatch += 'M' + rx.toFixed(1) + ' ' + (by + i2).toFixed(1) + 'l' + WL + ' ' + WL + ' ';
          }
          /* rotate(-90) bildet (x,y) auf (y,-x) ab: fuer die Zielposition
             rx+15 / Boxmitte heisst das x = -Boxmitte, y = rx+15. */
          el.wandtext.setAttribute('x', (-(by + bh / 2)).toFixed(1));
          el.wandtext.setAttribute('y', (rx + 15).toFixed(1));
          el.wandtext.setAttribute('transform', 'rotate(-90)');
          el.wandtext.removeAttribute('text-anchor');
        } else if (g.wand === 'links') {
          el.wandlinie.setAttribute('x1', bx.toFixed(1)); el.wandlinie.setAttribute('x2', bx.toFixed(1));
          el.wandlinie.setAttribute('y1', by.toFixed(1)); el.wandlinie.setAttribute('y2', (by + bh).toFixed(1));
          for (i2 = 0; i2 < bh; i2 += 9) {
            hatch += 'M' + bx.toFixed(1) + ' ' + (by + i2).toFixed(1) +
                     'l' + (-WL) + ' ' + WL + ' ';
          }
          el.wandtext.setAttribute('x', (by + bh / 2).toFixed(1));
          el.wandtext.setAttribute('y', (-(bx - 13)).toFixed(1));
          el.wandtext.setAttribute('transform', 'rotate(90)');
          el.wandtext.removeAttribute('text-anchor');
        } else {
          el.wandlinie.setAttribute('x1', bx.toFixed(1)); el.wandlinie.setAttribute('x2', (bx + bw).toFixed(1));
          el.wandlinie.setAttribute('y1', by.toFixed(1)); el.wandlinie.setAttribute('y2', by.toFixed(1));
          for (i2 = 0; i2 < bw; i2 += 9) {
            hatch += 'M' + (bx + i2).toFixed(1) + ' ' + by.toFixed(1) +
                     'l' + WL + ' ' + (-WL) + ' ';
          }
          /* 02.09. (Philipp): WAND stand mittig ueber der Box und kollidierte mit dem
             GESAMTBREITE-Mass, das dort ebenfalls sitzt. Jetzt links buendig an der Wandlinie. */
          el.wandtext.setAttribute('x', (bx + 4).toFixed(1));
          el.wandtext.setAttribute('y', (by - 12).toFixed(1));
          el.wandtext.removeAttribute('transform');
          el.wandtext.setAttribute('text-anchor', 'start');
        }
        el.wandhatch.setAttribute('d', hatch);
      } else {
        el.wand.setAttribute('hidden', '');
      }

      var vorderY;
      /* Mit Wand steht der Tisch nicht mehr mittig in der Box - Stuhl und
         Bemassung muessen ihm folgen, sonst zeigt die Grafik Unsinn. */
      var tischCX = CX;
      if (g.typ === 'rect') {
        var pw = g.ueber * sk, ph = g.D * sk;
        var px = bx + g.luftL * sk, py = by + g.hinten * sk;
        tischCX = px + pw / 2;
        el.platte.setAttribute('d', 'M' + px.toFixed(1) + ' ' + py.toFixed(1) +
          'h' + pw.toFixed(1) + 'v' + ph.toFixed(1) + 'h' + (-pw).toFixed(1) + 'Z');
        /* Die gefalteten Wangen sichtbar machen - sie sind der Grund fuer die
           13 cm je Stirnseite, nicht die Schweizer Kante. */
        var ww = EHB_WANGE * sk;
        [[el.wangeL, px], [el.wangeR, px + pw - ww]].forEach(function (pr) {
          pr[0].removeAttribute('hidden');
          pr[0].setAttribute('x', pr[1].toFixed(1)); pr[0].setAttribute('y', py.toFixed(1));
          pr[0].setAttribute('width', ww.toFixed(1)); pr[0].setAttribute('height', ph.toFixed(1));
        });
        vorderY = py + ph;
        /* Gesamtbreite (Philipps Wording) im Durchgang ueber der Platte -
           unten steht der Stuhl, oben ist Luft. */
        var my = py - 14;
        el.ml.setAttribute('x1', px.toFixed(1)); el.ml.setAttribute('x2', (px + pw).toFixed(1));
        el.ml.setAttribute('y1', my.toFixed(1)); el.ml.setAttribute('y2', my.toFixed(1));
        el.mk1.setAttribute('x1', px.toFixed(1)); el.mk1.setAttribute('x2', px.toFixed(1));
        el.mk2.setAttribute('x1', (px + pw).toFixed(1)); el.mk2.setAttribute('x2', (px + pw).toFixed(1));
        [el.mk1, el.mk2].forEach(function (k) {
          k.setAttribute('y1', (my - 4).toFixed(1)); k.setAttribute('y2', (my + 4).toFixed(1));
        });
        el.mt.setAttribute('x', tischCX.toFixed(1)); el.mt.setAttribute('y', (my - 9).toFixed(1));
        el.mt.removeAttribute('transform');
        el.mtl.textContent = '';
        el.mtz.textContent = Math.round(g.ueber) + ' cm';
        el.mlb.setAttribute('x', tischCX.toFixed(1)); el.mlb.setAttribute('y', (my - 22).toFixed(1));
        el.mlb.removeAttribute('transform');
        el.mlb.textContent = 'GESAMTBREITE';
        [el.hl1, el.hl2].forEach(function (h) {
          h.setAttribute('x1', 0); h.setAttribute('x2', 0); h.setAttribute('y1', 0); h.setAttribute('y2', 0);
        });
      } else {
        el.wangeL.setAttribute('hidden', ''); el.wangeR.setAttribute('hidden', '');
        /* An der linken Boxkante ausrichten. Ergibt fuer 'frei' exakt dieselbe
           Lage wie die fruehere Mittenrechnung, traegt aber die Wandvarianten mit. */
        var ox = bx + g.luftL * sk - g.minX * sk;
        var oy = by + g.hinten * sk;
        var d = g.pts.map(function (p, i) {
          return (i ? 'L' : 'M') + (ox + p.x * sk).toFixed(1) + ' ' + (oy + p.y * sk).toFixed(1);
        }).join(' ') + 'Z';
        el.platte.setAttribute('d', d);
        /* Fix 01.09.: Der Stuhl stand bisher auf CX statt auf der Innenecke.
           Bei 230x170 waren das 26 cm daneben, bei 260x210 19 cm - nur die
           symmetrische 210x210 stimmte zufaellig. Die Innenecke ist pts[4]:
           fuer 'frei' liegt sie lokal auf (0, sy), in der Wandvariante kommt
           sie bereits gedreht aus der Geometrie - der Anker folgt ihr. */
        tischCX = ox + g.pts[4].x * sk;
        vorderY = oy + g.pts[4].y * sk;
        /* Bemassung GERADE und oben (Philipp 25.08.: "eine Bemassung macht man
           nicht schraeg") - aber ueber dem Scheitel statt durch ihn hindurch.
           Der Platz bis zur Boxkante betraegt nur ~33px, darum stehen Label und
           Zahl in EINER Zeile. */
        var ax = ox + g.pts[0].x * sk, bx2 = ox + g.pts[2].x * sk;
        var ay1 = oy + g.pts[0].y * sk, by2 = oy + g.pts[2].y * sk;
        var my2 = oy - 11; /* 11px Luft ueber der Scheitelspitze */
        [[el.hl1, ax, ay1], [el.hl2, bx2, by2]].forEach(function (h) {
          h[0].setAttribute('x1', h[1].toFixed(1)); h[0].setAttribute('x2', h[1].toFixed(1));
          h[0].setAttribute('y1', (my2 + 4).toFixed(1)); h[0].setAttribute('y2', h[2].toFixed(1));
        });
        el.ml.setAttribute('x1', ax.toFixed(1)); el.ml.setAttribute('x2', bx2.toFixed(1));
        el.ml.setAttribute('y1', my2.toFixed(1)); el.ml.setAttribute('y2', my2.toFixed(1));
        el.mk1.setAttribute('x1', ax.toFixed(1)); el.mk1.setAttribute('x2', ax.toFixed(1));
        el.mk2.setAttribute('x1', bx2.toFixed(1)); el.mk2.setAttribute('x2', bx2.toFixed(1));
        [el.mk1, el.mk2].forEach(function (k) {
          k.setAttribute('y1', (my2 - 4).toFixed(1)); k.setAttribute('y2', (my2 + 4).toFixed(1));
        });
        el.mt.setAttribute('x', ((ax + bx2) / 2).toFixed(1)); el.mt.setAttribute('y', (my2 - 9).toFixed(1));
        el.mt.removeAttribute('transform');
        if (g.wand) {
          /* An der Wand laeuft die Spannweite diagonal durchs Bild - eine
             schraege Masslinie verbietet sich (Philipp 25.08.: "eine Bemassung
             macht man nicht schraeg"). Die waagerechte Linie misst darum das,
             was sie wirklich zeigt: das Gesamtmass des gedrehten Tischs von
             der Wand in den Raum. pts[0] und pts[2] sind auch gedreht die
             aeussersten Punkte, Linie, Hilfslinien und Zahl passen zusammen -
             sonst wuerde das sichtbare 1-m-Raster die Zahl Luegen strafen. */
          el.mtl.textContent = 'GESAMTBREITE\u2002';
          el.mtz.textContent = ehbM(g.maxX - g.minX) + ' m';
        } else {
          el.mtl.textContent = 'SPANNWEITE\u2002';
          el.mtz.textContent = ehbM(g.spann) + ' m';
        }
        el.mlb.textContent = '';
        el.mlb.removeAttribute('transform');
      }
      /* Stuhl sitzt immer an der Arbeitskante, massstabsgetreu ~55 cm breit */
      var sb = 55 * sk, st = 52 * sk, sy2 = vorderY + st * 0.62;
      el.sitz.setAttribute('x', (tischCX - sb / 2).toFixed(1)); el.sitz.setAttribute('y', sy2.toFixed(1));
      el.sitz.setAttribute('width', sb.toFixed(1)); el.sitz.setAttribute('height', (st * 0.62).toFixed(1));
      el.lehne.setAttribute('x', (tischCX - sb / 2).toFixed(1));
      el.lehne.setAttribute('y', (sy2 + st * 0.70).toFixed(1));
      el.lehne.setAttribute('width', sb.toFixed(1)); el.lehne.setAttribute('height', (st * 0.15).toFixed(1));
      /* Sitz und Lehne sind achsparallele Rechtecke. In der Arc-Wandvariante
         ist der Tisch um 30 Grad gedreht - der Stuhl muss mit, sonst steht er
         schief zur Tischkante. Gedreht wird um die Innenecke (tischCX/vorderY):
         so bleibt die Stuhl-Tisch-Beziehung exakt die freigegebene aus 'frei',
         nur eben mitgedreht. SVG-rotate laeuft bei positivem Winkel im
         Uhrzeigersinn (y zeigt nach unten) - dieselbe Richtung wie die
         Punktdrehung der Geometrie, darum stimmen beide 30er ueberein. */
      if (g.dreh) {
        el.stuhl.setAttribute('transform',
          'rotate(' + g.dreh + ' ' + tischCX.toFixed(1) + ' ' + vorderY.toFixed(1) + ')');
      } else {
        el.stuhl.removeAttribute('transform');
      }

      /* Bewegungsflaeche: Breite unten, Tiefe rechts - direkt an der Kante. */
      var gy = by + bh + 12;
      el.gb.setAttribute('x1', bx.toFixed(1)); el.gb.setAttribute('x2', (bx + bw).toFixed(1));
      el.gb.setAttribute('y1', gy.toFixed(1)); el.gb.setAttribute('y2', gy.toFixed(1));
      el.gb1.setAttribute('x1', bx.toFixed(1)); el.gb1.setAttribute('x2', bx.toFixed(1));
      el.gb2.setAttribute('x1', (bx + bw).toFixed(1)); el.gb2.setAttribute('x2', (bx + bw).toFixed(1));
      [el.gb1, el.gb2].forEach(function (k) {
        k.setAttribute('y1', (gy - 4).toFixed(1)); k.setAttribute('y2', (gy + 4).toFixed(1));
      });
      el.gbz.setAttribute('x', (bx + bw / 2).toFixed(1)); el.gbz.setAttribute('y', (gy + 15).toFixed(1));
      el.gbz.textContent = ehbM(g.boxB) + ' m';
      var gx = bx + bw + 11;
      el.gr.setAttribute('x1', gx.toFixed(1)); el.gr.setAttribute('x2', gx.toFixed(1));
      el.gr.setAttribute('y1', by.toFixed(1)); el.gr.setAttribute('y2', (by + bh).toFixed(1));
      el.gr1.setAttribute('y1', by.toFixed(1)); el.gr1.setAttribute('y2', by.toFixed(1));
      el.gr2.setAttribute('y1', (by + bh).toFixed(1)); el.gr2.setAttribute('y2', (by + bh).toFixed(1));
      [el.gr1, el.gr2].forEach(function (k) {
        k.setAttribute('x1', (gx - 4).toFixed(1)); k.setAttribute('x2', (gx + 4).toFixed(1));
      });
      var gmy = by + bh / 2;
      el.grz.setAttribute('x', (gx + 13).toFixed(1)); el.grz.setAttribute('y', gmy.toFixed(1));
      el.grz.setAttribute('transform', 'rotate(-90 ' + (gx + 13).toFixed(1) + ' ' + gmy.toFixed(1) + ')');
      el.grz.textContent = ehbM(g.boxT) + ' m';
    }


    /* Weiche Ueberblendung: interpoliert werden die Rohmasse, nicht die
       SVG-Attribute - so bleibt die Geometrie in jedem Zwischenbild korrekt. */
    var lauf = null, aktuell = null;
    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function rohwerte(s) {
      if (istArc) { var w = EHB_ARC_SCHENKEL[s.label] || [s.L, s.D]; return [w[0], w[1]]; }
      return [s.L, s.D];
    }
    function geoAusRoh(r) { return istArc ? ehbGeoArc(r[0], r[1], ehbStellung) : ehbGeoRect(r[0], r[1], ehbStellung); }

    function zeigeSofort(s) {
      aktuell = rohwerte(s);
      zeichne(geoAusRoh(aktuell));
    }
    function animiereZu(s) {
      var ziel = rohwerte(s), von = aktuell ? aktuell.slice() : ziel.slice();
      var t0 = null, DUR = 420;
      if (lauf) cancelAnimationFrame(lauf);
      function schritt(ts) {
        if (t0 === null) t0 = ts;
        var t = Math.min(1, (ts - t0) / DUR), e = ease(t);
        var r = von.map(function (v, i) { return v + (ziel[i] - v) * e; });
        zeichne(geoAusRoh(r));
        if (t < 1) { lauf = requestAnimationFrame(schritt); } else { aktuell = ziel; lauf = null; }
      }
      lauf = requestAnimationFrame(schritt);
    }

    /* Pillen-Slider (Wireframe B, Philipp 25.08.): der Griff IST die
       Groessenanzeige. Der native input liegt unsichtbar darueber und liefert
       Bedienung samt Tastatur - Pille, Fuellung und Rastpunkte folgen ihm. */
    /* Aufstellung umschalten (Philipp 01.09.). */
    var stellWahl = box.querySelector('[data-ehb-raum-stellung]');
    if (stellWahl) {
      ehbStellung = 'frei';
      {
        /* ArcPURE hat genau EINE Wandlage (Philipp 01.09.): die lange Seite
           steht senkrecht zur Wand, "Wand hinter dem Winkel" ist gestrichen.
           Der Knopf ist derselbe wie bei den geraden Tischen, weil er fachlich
           dasselbe meint - 'kurz' gibt es fuer den Winkel nicht. */
        var erlaubt = istArc ? ['frei', 'lang'] : ['frei', 'kurz', 'lang'];
        [].forEach.call(stellWahl.querySelectorAll('[data-stellung]'), function (x) {
          var an = erlaubt.indexOf(x.getAttribute('data-stellung')) >= 0;
          x.hidden = !an;
          /* 29.09. (Philipp): beim ArcPURE steht die kurze Seite des linken, langen Fluegels an der Wand */
          if (x.getAttribute('data-stellung') === 'lang') x.textContent = istArc ? 'Kurze Seite des langen Flügels an der Wand' : 'Lange Seite an der Wand';
          x.classList.toggle('is-an', x.getAttribute('data-stellung') === 'frei');
          x.setAttribute('aria-checked', x.getAttribute('data-stellung') === 'frei' ? 'true' : 'false');
        });
        stellWahl.removeAttribute('hidden');
        stellWahl.addEventListener('click', function (ev) {
          var b2 = ev.target.closest('[data-stellung]');
          if (!b2 || b2.getAttribute('data-stellung') === ehbStellung) return;
          ehbStellung = b2.getAttribute('data-stellung');
          [].forEach.call(stellWahl.querySelectorAll('[data-stellung]'), function (x) {
            var an = x === b2;
            x.classList.toggle('is-an', an);
            x.setAttribute('aria-checked', an ? 'true' : 'false');
          });
          var hin = box.querySelector('[data-ehb-raum-wandhinweis]');
          if (hin) hin.hidden = (ehbStellung === 'frei');
          sync(parseInt(slider.value, 10) || 0, false);
        });
      }
    }

    var slider = box.querySelector('[data-ehb-raum-slider]');
    var griff = box.querySelector('[data-ehb-raum-label]');
    var ps = box.querySelector('[data-ehb-ps]');
    var fuell = box.querySelector('[data-ehb-ps-fuellung]');
    var uebernehmen = box.querySelector('[data-ehb-raum-uebernehmen]');
    var startIdx = Math.max(0, alle.findIndex(function (s) { return s.label === aktLabel; }));
    slider.max = String(alle.length - 1);
    slider.value = String(startIdx);
    slider.setAttribute('aria-valuetext', alle[startIdx].label);

    var lMin = box.querySelector('[data-ehb-ps-min]'), lMax = box.querySelector('[data-ehb-ps-max]');
    if (lMin) lMin.textContent = alle[0].label.replace(/x/i, ' × ');
    if (lMax) lMax.textContent = alle[alle.length - 1].label.replace(/x/i, ' × ');
    var ticks = alle.map(function (_, i) {
      var t = document.createElement('div');
      t.className = 'ehb-raum__tick';
      t.style.left = (alle.length > 1 ? (i / (alle.length - 1)) * 100 : 50) + '%';
      ps.insertBefore(t, slider);
      return t;
    });
    function positioniere(f) {
      /* Pixelmessung erst nach dem Layout - das Modal ist gerade erst offen. */
      requestAnimationFrame(function () {
        var w = ps.offsetWidth, gw = griff.offsetWidth || 90;
        griff.style.left = (gw / 2 + f * (w - gw)) + 'px';
      });
    }
    function sync(idx, sofort) {
      var s = alle[idx];
      var f = alle.length > 1 ? idx / (alle.length - 1) : 1;
      griff.textContent = s.label.replace(/x/i, ' × ');
      positioniere(f);
      if (fuell) fuell.style.width = (f * 100) + '%';
      ticks.forEach(function (t, n) { t.classList.toggle('is-voll', n <= idx); });
      slider.setAttribute('aria-valuetext', s.label);
      if (sofort) zeigeSofort(s); else animiereZu(s);
      if (uebernehmen) {
        var anders = s.label !== aktLabel;
        uebernehmen.hidden = !anders;
        uebernehmen.setAttribute('data-ehb-ziel', s.label);
      }
    }
    slider.addEventListener('input', function () { sync(parseInt(slider.value, 10) || 0, false); });
    if (uebernehmen) {
      uebernehmen.addEventListener('click', function () {
        var ziel = uebernehmen.getAttribute('data-ehb-ziel');
        /* Echten Chip klicken statt State setzen: so laeuft dieselbe Logik
           (Finish-Reset, updateAll) und der Ad-Tracker zaehlt den Schritt. */
        var chip = [].slice.call(root.querySelectorAll(chipSelektor))
          .find(function (b) {
            var wert = b.getAttribute('data-mk-size') || b.textContent || '';
            return wert.trim().replace(/\s/g, '') === ziel.replace(/\s/g, '');
          });
        if (chip) chip.click();
        setOpen(false);
      });
    }
    sync(startIdx, true);
  }


  window.EHB_RAUM = function (ctx) {
    currentModel = ctx.currentModel; state = ctx.state; root = ctx.root;
    getStandardSizesFor = ctx.getStandardSizesFor; setOpen = ctx.setOpen; eigen = ctx.eigen || null;
    chipSelektor = ctx.chipSelektor || '[data-role="size-list"] button';
    return { montiere: ehbRaumMontiere };
  };
})();
